import { Record, List } from 'immutable';

const TargetLanguageCategoryRecord = Record({
  title: undefined,
  items: new List(),
});

class TargetLanguageCategory extends TargetLanguageCategoryRecord { }

TargetLanguageCategory.create = (data) => new TargetLanguageCategory(data);

export default TargetLanguageCategory;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/TargetLanguageCategories/model.js